<template>
  <div>
    <div class="w-100 cover"></div>
    <div class="f2-ns f3 mt3">
        <div class="w-100 tc">Let's work together!</div>
        <div class="w-25-ns w-100 center mv4 f4 info tc">
          <div class="pa3-ns pa2 b1 ttu">United Builders Group</div>
          <a href="tel:12129622780" class="tc dim black link"><div>(212)962 2780</div></a>
          <a class="tc dim black link" target="_" href="https://goo.gl/maps/Fc5ohZ4qLWVtxo917">
          <div class="pa2">
            139 Fulton Street<br/>
            Suite 210, NY 10038
          </div>
          </a>
          <a href="mailto:info@unitedbuildersgroup.com" class="tl dim black link">
            info@unitedbuildersgroup.com
          </a>
      </div>
      <div class="tc center">
        <iframe class="w-33-ns w-100 tc" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.3429724931534!2d-74.00995598439003!3d40.710465745646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a181565da7d%3A0xff49ee1e6a8ef416!2sUnited%20Builders%20Group%20LLC!5e0!3m2!1sen!2sus!4v1573949549226!5m2!1sen!2sus" width="400" height="300" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div>
      
    <!-- <Form/> -->
  </div>
  </div>
</template>

<script>
import Form from '@/components/Form.vue'
export default {
  name: 'Contact',
  components: { Form }
}
</script>

<style scoped>
.b1 {
  font-weight: 500;
}
.cover {
  background: url('https://images.unsplash.com/photo-1462899006636-339e08d1844e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80');
  /* background: url('https://images.unsplash.com/photo-1553013746-fd5454da7078?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80'); */
  /* https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20(1%20of%201)-5.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'); */
  height: 70vh;
  background-position: 80% 70%;
  text-align: center;
  margin: auto;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) { 
  .cover {
    background-position: 54% 0%;
  }
}
/* .mapouter {
  position:relative;
  text-align:right;
  max-height:500px;
  max-width:600px;
}
.gmap_canvas {
  overflow:hidden;
  background:none !important;
  max-height:500px;
  max-width:600px;
} */
</style>
